import { MarketingCampaignType, Offer, ThresholdMarketingCampaignConfig, } from '../../1_types/genericTypes';

export const getTitleFromOffer = (offer: Offer): string => {
  if (!offer) return '';
  const config = offer.config as ThresholdMarketingCampaignConfig;
  switch (offer.type) {
    case MarketingCampaignType.FIXED_AMOUNT_DISCOUNT_AFTER_THRESHOLD:
      return `-${config.discount.value}€ dès ${config.threshold}€ d'achat`;

    case MarketingCampaignType.GLOBAL_PRODUCT_DISCOUNT_AFTER_THRESHOLD:
      return `-${config.discount.value}% dès ${config.threshold}€ d'achat`;

    case MarketingCampaignType.FREE_DELIVERY_AFTER_THRESHOLD:
      return `Livraison offerte dès ${config.threshold}€ d'achat`;

    case MarketingCampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD:
      return `-${config.discount.value}% dès ${config.threshold}€ d'achat*`;

    default:
      break;
  }
  return '';
};